export function Home() {
  return (
    <div className="min-h-[100dvh] flex flex-col">
      <section
        className="relative flex-1 flex items-center min-h-[90vh]"
        style={{
          backgroundImage:
            "url('https://storage.stardeck.ai/images/5f29f015-4afb-4fbb-ba39-9435469a7508.png')",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
        aria-label="Monochrome club crowd background"
      >
        <div
          className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/50 to-black/70"
          aria-hidden="true"
        />
        <div className="relative mx-auto w-full max-w-6xl px-6 py-28 text-white">
          <div className="grid gap-6 md:grid-cols-12">
            <div className="md:col-span-8 space-y-5">
              <div className="inline-block bg-black text-white text-[10px] px-2 py-1 border-2 border-white uppercase tracking-widest">
                Artist
              </div>
              <h1 className="text-[clamp(48px,8vw,120px)] font-bold leading-[0.88] tracking-tight">
                CHRN
              </h1>
              <p className="text-base md:text-lg text-neutral-200 max-w-xl uppercase">
                Monochrome electronic. Night bus energy.
              </p>
              <div className="flex flex-wrap gap-2 pt-2">
                <a
                  href="#spotify"
                  className="inline-flex items-center border-2 border-white bg-white text-black h-12 px-6 text-xs font-bold uppercase tracking-wider hover:bg-transparent hover:text-white transition-colors"
                >
                  Spotify
                </a>
                <a
                  href="#soundcloud"
                  className="inline-flex items-center border-2 border-white text-white h-12 px-6 text-xs font-bold uppercase tracking-wider hover:bg-white hover:text-black transition-colors"
                >
                  SoundCloud
                </a>
              </div>
            </div>
            <div className="md:col-span-4 self-start">
              <div className="relative bg-black/60 border-4 border-white p-5 md:p-6">
                <div
                  className="absolute inset-0 pointer-events-none"
                  style={{
                    backgroundImage: "radial-gradient(rgba(255,255,255,0.25) 1px, transparent 1px)",
                    backgroundSize: "6px 6px",
                    opacity: 0.15,
                  }}
                />
                <div className="relative font-mono text-[10px] md:text-xs uppercase tracking-[0.35em] text-white/80 drop-shadow-[0_0_8px_rgba(255,255,255,0.7)]">
                  Now Playing
                </div>
                <div className="relative mt-2 text-xl md:text-2xl font-black text-white uppercase drop-shadow-[0_0_14px_rgba(255,255,255,0.75)]">
                  Bangkok · September 25, 2025
                </div>
                <div className="relative mt-4 h-1 w-full bg-white/20">
                  <div className="h-1 w-2/3 bg-white shadow-[0_0_16px_2px_rgba(255,255,255,0.9)]" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="border-y-2 border-border bg-secondary">
        <div className="mx-auto w-full max-w-6xl px-6 py-12 space-y-6">
          <div className="flex items-center justify-between">
            <h2 className="text-2xl font-extrabold uppercase tracking-tight">Latest</h2>
            <span className="text-[10px] uppercase tracking-widest">Monochrome Only</span>
          </div>
          <div className="grid md:grid-cols-2 gap-6">
            <div className="border-2 border-border bg-background p-4">
              <div className="aspect-video bg-muted flex items-center justify-center text-xs uppercase text-muted-foreground">
                Embed Spotify here
              </div>
            </div>
            <div className="border-2 border-border bg-background p-4">
              <div className="aspect-video bg-muted flex items-center justify-center text-xs uppercase text-muted-foreground">
                Embed SoundCloud here
              </div>
            </div>
          </div>
        </div>
      </section>

      <footer className="border-t border-border">
        <div className="mx-auto w-full max-w-5xl px-6 py-8 flex flex-col md:flex-row gap-4 md:gap-0 md:items-center md:justify-between text-sm text-muted-foreground">
          <span>© {new Date().getFullYear()} CHRN</span>
          <div className="flex gap-4">
            <a href="#spotify" className="hover:text-foreground">
              Spotify
            </a>
            <a href="#soundcloud" className="hover:text-foreground">
              SoundCloud
            </a>
          </div>
        </div>
      </footer>
    </div>
  );
}
